// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-inline {
  float: right;
  height: 18px;
  width: 18px;
}

.reorder-enabled ion-reorder {
  cursor: move;
  opacity: 0.4;
}

.checkbox-inline:focus-visible {
  outline: none;
}

.sc-ion-label-md-h {
  font-size: 14px;
}

.column-item {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  font-size: 1rem;
  font-weight: 700;
  text-align: start;
}
.column-item span {
  flex-grow: 1;
}

.right {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-end;
}

.reorder-inline {
  float: right;
  height: 20px;
  width: 20px;
  color: var(--color-black-light);
  font-weight: bold;
}

.checkbox-inline {
  float: right;
  height: 18px;
  width: 18px;
}

/* dark theme styles */
.dark .reorder-inline {
  color: var(--color-black-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/components/column-selector-list/column-selector-list.component.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/components/column-selector-list/column-selector-list.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,WAAA;ACCJ;;ADEA;EACI,YAAA;EACA,YAAA;ACCJ;;ADEA;EACI,aAAA;ACCJ;;ADEA;EACI,eAAA;ACCJ;;ADEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EAEA,kBAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;ACDJ;ADGI;EACI,YAAA;ACDR;;ADKA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;ACFJ;;ADKA;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,iBAAA;ACFJ;;ADKA;EACI,YAAA;EACA,YAAA;EACA,WAAA;ACFJ;;ADKA,sBAAA;AAEI;EACI,8BAAA;ACHR","sourcesContent":[".checkbox-inline {\r\n    float: right;\r\n    height: 18px;\r\n    width: 18px;\r\n}\r\n\r\n.reorder-enabled ion-reorder {\r\n    cursor: move;\r\n    opacity: 0.4;\r\n}\r\n\r\n.checkbox-inline:focus-visible {\r\n    outline: none\r\n}\r\n\r\n.sc-ion-label-md-h {\r\n    font-size: 14px;\r\n}\r\n\r\n.column-item {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 1.5rem;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    padding: 10px 16px;\r\n\r\n    font-size: 1rem;\r\n    font-weight: 700;\r\n    text-align: start;\r\n\r\n    span {\r\n        flex-grow: 1;\r\n    }\r\n}\r\n\r\n.right {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: nowrap;\r\n    gap: .5rem;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.reorder-inline {\r\n    float: right;\r\n    height: 20px;\r\n    width: 20px;\r\n    color: var(--color-black-light);\r\n    font-weight: bold;\r\n}\r\n\r\n.checkbox-inline {\r\n    float: right;\r\n    height: 18px;\r\n    width: 18px;\r\n}\r\n\r\n/* dark theme styles */\r\n.dark {\r\n    .reorder-inline {\r\n        color: var(--color-black-dark);\r\n    }   \r\n}\r\n",".checkbox-inline {\n  float: right;\n  height: 18px;\n  width: 18px;\n}\n\n.reorder-enabled ion-reorder {\n  cursor: move;\n  opacity: 0.4;\n}\n\n.checkbox-inline:focus-visible {\n  outline: none;\n}\n\n.sc-ion-label-md-h {\n  font-size: 14px;\n}\n\n.column-item {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 1.5rem;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;\n  font-size: 1rem;\n  font-weight: 700;\n  text-align: start;\n}\n.column-item span {\n  flex-grow: 1;\n}\n\n.right {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.reorder-inline {\n  float: right;\n  height: 20px;\n  width: 20px;\n  color: var(--color-black-light);\n  font-weight: bold;\n}\n\n.checkbox-inline {\n  float: right;\n  height: 18px;\n  width: 18px;\n}\n\n/* dark theme styles */\n.dark .reorder-inline {\n  color: var(--color-black-dark);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
